import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./lib/analytics";

// Initialize analytics before React renders
initAnalytics();

const queryClient = new QueryClient();

console.log('🟢 main.tsx: Starting app initialization');

const rootElement = document.getElementById("root");
console.log('🟢 main.tsx: Root element found:', !!rootElement);

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </StrictMode>
  );
  console.log('🟢 main.tsx: React app rendered');
} else {
  console.error('❌ main.tsx: Root element not found!');
}
